module.exports = __webpack_public_path__ + "static/img/dan-gold-E6HjQaB7UEA-unsplash_thumb.555376a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/dan-gold-E6HjQaB7UEA-unsplash_thumb.png
// module id = vai5
// module chunks = 4